import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Button from 'react-bootstrap/lib/Button';
import Form from 'react-bootstrap/lib/Form';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import {
  Redirect
} from 'react-router-dom';


const Withdraw = ({page, intl, user, content}) => {

    const { formatMessage } = intl;
    const thisPage = P.WITHDRAW_PAGE;

    const submit = e => {
        e.preventDefault()
        window.location = content.marketing_home_url;
      }
    const back = e => {
        e.preventDefault()
        window.location = `/hosts/signup/re_engage?uid=${user.id}&at=${user.hashed_access_token}`;
      }

    return (
      <div>
        <Redirector this_page={thisPage} page={page}/>
        <div className="text-center"><img src="/images/host-sign-up/smile.png" /></div>
        <FormHeader title={content.pages.withdraw.title}/>
        <p>{content.pages.withdraw.body}</p>
        <form>
          <Button type="submit" className='btn-primary btn-fixed-width pull-left' onClick={back}>{formatMessage(defaultMessages.clientCommonButtonsBack)}</Button>
          <Button type="submit" className='btn-default btn-fixed-width pull-right' onClick={submit}>{formatMessage(defaultMessages.clientCommonButtonsExit)}</Button>
        </form>
      </div>
    );
};

Withdraw.propTypes = {
   page: PropTypes.string,
   intl: PropTypes.object,
   user: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(Withdraw);
